const teladoc = 'Teladoc';
const surescripts = 'Surescripts';

const DATA_SOURCE_TRANSLATIONS = {
  'Admin Portal': teladoc,
  'Provider Portal': teladoc,
  'Provider Mobile': teladoc,
  'Member Portal': teladoc,
  'Member Mobile': teladoc,
  Surescripts: surescripts
};

export default DATA_SOURCE_TRANSLATIONS;
